__turbopack_context__.v({
  "dots": "dots-module__OsPr2G__dots",
});
